module.exports = __webpack_public_path__ + "img/va.31203e8c.png";